import CreateWidgetPage from './CreateWidgetPage';
export default CreateWidgetPage;
